import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

interface DrawerHeaderStyledProps {
  open?: boolean;
}

const DrawerHeaderStyled = styled(Box)(({ theme }) => ({
  minHeight: '64px' // just a spacer matching the header height — no logo here anymore
}));

export default DrawerHeaderStyled;
